import gql from 'graphql-tag'

export const main = gql`
	fragment salesGroupMain on SalesGroup {
		id
		name
		mod_ver
		acountNum
		discount
		accountingReduced
		accountingNormal
		accountingSpecial
		accountingZeroPercent
		clientDiscount {
			number
			percent
		}
	}
`
